/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description OK
 */
export const getApiProfileCvDownload200Schema = z.any();

export const getApiProfileCvDownloadQueryResponseSchema = z.lazy(
  () => getApiProfileCvDownload200Schema,
);
